import {
    FETCH_RETURN_LABEL_REQUEST,
    FETCH_RETURN_LABEL_SUCCESS,
    FETCH_RETURN_LABEL_ERROR,
    CLEAR_RETURN_LABEL,
} from '../constants/ActionTypes'

export default function returnLabel(state = { loading: false, success: false, error: null }, action) {
    switch (action.type) {
        case FETCH_RETURN_LABEL_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                error: null,
            }
        case FETCH_RETURN_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            }
        case FETCH_RETURN_LABEL_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error?.errors?.[0]?.errorKey || action.error?.message,
            }
        case CLEAR_RETURN_LABEL:
            return {
                ...state,
                loading: false,
                success: false,
                error: null,
            }
        default:
            return state
    }
}
